import { useAuth } from '@workos-inc/authkit-react';

/**
 * AuthKit's `useAuth` with one app default: signing out returns to this origin instead of the
 * WorkOS-configured logout redirect.
 */
export function useWorkOSAuth() {
  const auth = useAuth();
  const signOut = (options: { returnTo?: string } = {}) =>
    auth.signOut({ returnTo: options.returnTo ?? window.location.origin });

  return { ...auth, signOut };
}
